import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {GameConfig} from "./config/base/GameConfig";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {BaseModel} from "./server/base/BaseModel";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {PresentationManager} from "../core/gameflow/controller/PresentationManager";
import {Translator} from "../core/setting/Translator";
import {GameSetting} from "../core/setting/GameSetting";
import {LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {UniversalPlayer} from "../core/displayobject/UniversalPlayer";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {PresentationController} from '../core/gameflow/controller/PresentationController';
import {Speedster} from "../core/debug/Speedster";
import {Background} from './background/Background';
import {FeatureReelStopPresentation} from './presentations/reel/feature/FeatureReelStopPresentation';
import {TestTool} from "../core/debug/DataChecker/Internal/TestTool";
import {OverlayAnimation} from "./presentations/independent/animations/OverlayAnimation";
import {PREngineManager} from "./punkEngine/PREngineManager";
import {PunkSymbolData} from "./punkEngine/symbol/PunkSymbolData";
import {NormalStartPresentation} from "./presentations/reel/normal/NormalStartPresentation";
import {NormalStopPresentation} from "./presentations/reel/normal/NormalStopPresentation";
import {NormalWinPresentation} from "./presentations/features/win/normal/NormalWinPresentation";
import {PunkBitmapCountUp} from "./component/PunkBitmapCountUp";
import {GameAssets} from "./config/texture/GameAssets";
import {ReelStoppedPresentation} from "./presentations/reel/normal/ReelStoppedPresentation";
import {ZeroBetPresentation} from "./presentations/reel/normal/ZeroBetPresentation";
import {
    ModeRestoreTriggerPresentation,
    ModeTriggerPresentation
} from "./presentations/reel/normal/ModeTriggerPresentation";
import {PosterManager} from "./presentations/independent/Poster/PosterManager";
import {BigWinPresentation} from "./presentations/features/win/bigwin/BigWinPresentation";
import {SplashController} from "./presentations/independent/splashScreen/SplashController";
import {JumpingWildController} from "./presentations/independent/jumpingWild/JumpingWildController";
import {FSStartPresentation} from "./presentations/reel/normal/FSStartPresentation";
import {OutroPresentation} from "./presentations/reel/normal/OutroPresentation";
import {IdlePresentation} from "./presentations/reel/normal/IdlePresentation";
import {RespinRestorePresentation} from "./presentations/reel/normal/RespinRestorePresentation";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {PRGameMode} from "./server/PRGameMode";
import {GameLogo} from "./background/gameLogo";
import {SoundManager} from "./sound/SoundManager";
import {NolimitConfig} from "@nolimitcity/slot-launcher/bin/settings/NolimitConfig";
import {WaysCounter} from "./presentations/independent/WaysCounter";
import {TrainsManager} from "./presentations/independent/trains/TrainsManager";
import {BaseServerData} from "./server/base/IData";
import {CapWinPresentation} from "./presentations/features/win/capwin/CapWinPresentation";
import {CapWinView} from "./presentations/independent/splashScreen/CapWinView";
import {ScreenDimmer} from "./presentations/independent/splashScreen/ScreenDimmer";
import {FSOutroView} from "./presentations/independent/splashScreen/FSOutroView";
import {InitData} from "./server/data/InitData";
import {TemplateAsset, TemplateLoader} from "@nolimitcity/slot-launcher/bin/loader/TemplateLoader";
import {ISymbolValues} from "../core/extra/MiniPayTable";
import {BigWinView} from "./presentations/independent/splashScreen/BigWinView";
import {PipeBombPresentation} from "./presentations/reel/normal/PipeBombPresentation";
import {PRFadedWinView} from "./presentations/features/win/normal/PRFadedWinView";
import {NoServiceView} from "./presentations/independent/trains/NoServiceView";
import {gsap} from "gsap";
import {PunkSymbol} from "./punkEngine/symbol/PunkSymbol";
import {
    FSPauseBetweenSpinsPresentation
} from "./presentations/independent/FSPauseBetweenSpinsPresentation";
import {OtherOverlays} from "./presentations/independent/animations/OtherOverlays";
import {Foreground} from "./foreground/Foreground";
import {Skinner} from "./Skinner";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";

export class PunkRocker extends SlotGame {
    public static IS_BOOSTED_BET: boolean = false;
    public static SYMBOLS_NUM_IN_REEL: number[] = [3, 3, 3, 3, 3, 3]; // #319 -> only using it for xWays.
    public static BURNING_JUMPING_WILDS_COUNT: number;

    public static assetLoader: AssetLoader;
    public static translate: Translator;
    public static gameSetting: GameSetting;
    public static symbolData: PunkSymbolData;
    public static screenDimmer: ScreenDimmer;
    public static background: Background;
    public static gameLogo: GameLogo;
    public static counter: PunkBitmapCountUp;
    public static fadedWinView: PRFadedWinView;
    public static trainsManager: TrainsManager;
    public static waysCounter: WaysCounter;
    public static noService: NoServiceView;
    public static posterManager: PosterManager;
    public static jumpWilds: JumpingWildController;
    public static capWinView: CapWinView;
    public static bigWinView: BigWinView;
    public static fsOutro: FSOutroView;
    public static splashController: SplashController;
    public static reelEngineManager: PREngineManager;
    public static overlayAnim: OverlayAnimation;
    public static otherOverlays: OtherOverlays;
    public static normalIdle: IdlePresentation;
    public static model: BaseModel;
    public static foreground: Foreground;

    private static gameFlowController: GameFlowController;
    private static presentationManager: PresentationManager;
    private skinner:Skinner;

    constructor() {
        super();
        const validSkinIds:string[] = [
            "ug",
            "ozzo",
            "test",
            "sweep"
        ]
        this.skinner = new Skinner(validSkinIds);
    }


    private handleSweepInit() {
        //Making sure that skinID is set based  on "replaceWordFree" gcc.
        if (SlotGame.apiPlugin.gameClientConfiguration.isSet) {
            if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                this.skinner.skinId = "sweep";
            }
        } else {
            SlotGame.apiPlugin.events.on(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                    this.skinner.skinId = "sweep";
                }
            })
        }
    }

    getNoWinGameData(): any {
        return GameConfig.NO_WIN_GAME_DATA;
    }

    // #264
    public static checkIfRevealedSymIsLow(mysterySymbol: string): boolean {
        return (mysterySymbol.length == 2 && !isNaN(parseInt(mysterySymbol[1])) && mysterySymbol[0] === "L");
    }

    // #264
    public static checkAndApplyChalkDividerOnMysteryTransform(reelId: number, symId: number, currSym: PunkSymbol | undefined, isCurrentSymLowValue: boolean): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        if (currSym && isCurrentSymLowValue) {
            const symAbove: PunkSymbol | undefined = PREngineManager.AllReels[reelId].getSymbol(symId - 1),
                symBelow: PunkSymbol | undefined = PREngineManager.AllReels[reelId].getSymbol(symId + 1);

            if (symId > 0 && symAbove && symAbove.isLowValue) {
                symAbove.createDivider(true);

                tl.add(symAbove.enableDivider(true), 0);
            }

            if ((symId < PREngineManager.AllReels[reelId].AllWindowSymbols.length) && symBelow && symBelow.isLowValue) {
                currSym.createDivider(true, true);

                tl.add(currSym.enableDivider(true, true), 0);
            }
        }

        return tl;
    }

    public getReadyToStart(): Promise<NolimitPlugin> {
        return super.getReadyToStart().then((value: NolimitPlugin) => {
            // #369
            SoundManager.playAmbientLoop(PRGameMode.NORMAL);

            return value;
        });
    }

    public getReady(): Promise<NolimitPlugin> {
        //Show intro and load game assets
        return super.getReady().then((value: NolimitPlugin) => {
            PunkRocker.assetLoader = new AssetLoader(PunkRocker.apiPlugin, NolimitApplication.resourcePath + "/resources/");

            const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
            imgLoader.add("S_overlay", "resources/images/S_overlay.png");

            const promises =  Promise.all([PunkRocker.assetLoader.load(ResourcesGroupName.MAIN), imgLoader.load()]);
            return promises.then((values: any) => {
                UniversalPlayer.setLoader(PunkRocker.assetLoader);

                (PunkRocker.symbolData = new PunkSymbolData(PunkRocker.assetLoader, GameConfig.DEFAULT_SYMBOL_DIM)).parseInitDataForInit(PunkRocker.model.initData);

                PunkRocker.presentationManager.initPresentations();

                // #383, #366, #222 => all these are inter related.
                const TEXTURE_HEIGHT: number = 180,
                    sizes: { size: number, height: number }[] = [
                        {size: 1, height: 180},
                        {size: 2, height: 135},
                        {size: 3, height: 108},
                        {size: 4, height: 90},
                        {size: 6, height: 60},
                        {size: 8, height: 45},
                        {size: 10, height: 36},
                        {size: 15, height: 24},
                        {size: 20, height: 18}
                    ];
                ["L1", "L2", "L3", "L4", "L5"].forEach((symbolName: string) => {
                    sizes.forEach((item: { size: number, height: number }) => {
                        const symTextureName: string = `large_${symbolName}`,
                            baseTexture: PIXI.Texture = PunkRocker.assetLoader.getTextures(symTextureName)[0],
                            frame: PIXI.Rectangle = baseTexture.frame.clone(),
                            splitHeight: number = item.height;

                        frame.y += ((item.size > 4 && symbolName === "L2") ? (63) : (Math.ceil((TEXTURE_HEIGHT - splitHeight) / 2)));

                        frame.height = splitHeight;
                        PIXI.Texture.addToCache(new PIXI.Texture(baseTexture.baseTexture, frame), `expandingSymbols/${symbolName}/${item.size}/${symbolName}`);
                    });
                });

                this.createViewsAndComponents();

                if (this.skinner.skinId != undefined) {
                    //Source folder for skin assets e.g "resources/images/skinName";
                    const assetPath:string = "resources/images/";
                    const replaceMap:Map<string, string> = new Map();


                    if(this.skinner.skinId === "sweep"){
                        replaceMap.set("BOOSTED_BET", "BOOSTED_BET.png");
                        replaceMap.set("BOOSTED_BET_1", "BOOSTED_BET_1.png");
                        replaceMap.set("BOOSTED_BET_2", "BOOSTED_BET_2.png");
                    }else{
                        //Intro
                        replaceMap.set("logo", "introLogo.png");
                        replaceMap.set("feature", "intro_feature.png");
                        replaceMap.set("feature2", "intro_feature2.png");

                        //Bonus
                        replaceMap.set("FREESPIN_LEVEL_ONE", "FREESPIN_LEVEL_ONE.png");
                        replaceMap.set("FREESPIN_LEVEL_TWO", "FREESPIN_LEVEL_TWO.png");
                        replaceMap.set("FREESPIN_LEVEL_THREE", "FREESPIN_LEVEL_THREE.png");


                        //Game logo
                        replaceMap.set("Game_Logo", "Game_Logo.png");

                        //Symbols
                        replaceMap.set("S_overlay", "S_overlay.png");

                        //AS
                        replaceMap.set("AS_GAME_LOGO", "AS_GAME_LOGO.png");

                    }

                    this.skinner.loadSkin(assetPath, replaceMap).then(()=>{
                        return value;
                    });
                }

                return value;
            });
        });
    }

    public init(): Promise<NolimitPlugin> {
        return super.init().then((value: NolimitPlugin) => {
            if (NolimitConfig.isDevMode) {
                (<any>globalThis).__PIXI_APP__ = NolimitApplication.pixiApp;
            }
            PunkRocker.translate = new Translator(PunkRocker.apiPlugin.translations.translate);
            PunkRocker.gameSetting = new GameSetting(PunkRocker.apiPlugin);
            PunkRocker.model = new BaseModel(PunkRocker.apiPlugin);
            PunkRocker.model.logger.level = LogLevel.DEV;

            AssetsConfig.addToAssetsConfig(GameAssets.RESOURCES_GROUPS);

            PunkRocker.gameFlowController = new GameFlowController(PunkRocker.apiPlugin, PunkRocker.model);
            PunkRocker.gameFlowController.flowStateLogger.level = LogLevel.DEV;

            PunkRocker.presentationManager = new PresentationManager(PunkRocker.model);

            PunkRocker.apiPlugin.events.on(APIEvent.SELECTED_FEATURE_BET_CHANGED, this.onSelectedFeatureBetChanged);

            PunkRocker.normalIdle = new IdlePresentation();
            let normalStart = new NormalStartPresentation();
            let normalStop = new NormalStopPresentation();
            let normalStopped = new ReelStoppedPresentation();
            let pipeBombAction = new PipeBombPresentation();
            let normalWin = new NormalWinPresentation();

            let bigWin = new BigWinPresentation();
            let capWin = new CapWinPresentation();

            let modePresentation = new ModeTriggerPresentation();
            let modeRestorePresentation = new ModeRestoreTriggerPresentation();
            let respinRestorePresentation: RespinRestorePresentation = new RespinRestorePresentation();
            let zeroBet = new ZeroBetPresentation();

            let featurePlay = new FeatureReelStopPresentation();

            let freeSpinRestore = new FeatureReelStopPresentation();

            // #253 -> 3rd point
            const fsPauseBetweenSpins: FSPauseBetweenSpinsPresentation = new FSPauseBetweenSpinsPresentation();

            PunkRocker.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.NORMAL, new Map<FlowState, PresentationController>([
                [FlowState.IDLE, PunkRocker.presentationManager.addController([
                    PunkRocker.normalIdle
                ], GameMode.NORMAL)],

                [FlowState.BET, PunkRocker.presentationManager.addController([
                    normalStart
                ], GameMode.NORMAL)],

                [FlowState.RESULT, PunkRocker.presentationManager.addController([
                    normalStop,
                    normalStopped,
                    pipeBombAction
                ], GameMode.NORMAL)],

                [FlowState.WIN, PunkRocker.presentationManager.addController([
                    normalWin,
                    bigWin,
                    capWin,
                    modePresentation,
                    //  new OutroPresentation()
                ], GameMode.NORMAL)],
            ]));

            PunkRocker.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.RESPIN, new Map<FlowState, PresentationController>([
                [FlowState.IDLE, PunkRocker.presentationManager.addController([
                    zeroBet
                ], GameMode.RESPIN)],

                [FlowState.BET, PunkRocker.presentationManager.addController([
                    respinRestorePresentation,
                    normalStart
                ], GameMode.RESPIN)],

                [FlowState.RESULT, PunkRocker.presentationManager.addController([
                    normalStop,
                    normalStopped,
                    pipeBombAction
                ], GameMode.RESPIN)],

                [FlowState.WIN, PunkRocker.presentationManager.addController([
                    normalWin,
                    bigWin,
                    capWin,
                    modePresentation
                ], GameMode.RESPIN)],
            ]));

            PunkRocker.gameFlowController.addGameModeFlowStatePresentationMap(PRGameMode.FREESPIN_LEVEL_ONE, new Map<FlowState, PresentationController>([
                [FlowState.IDLE, PunkRocker.presentationManager.addController([
                    zeroBet
                ], PRGameMode.FREESPIN_LEVEL_ONE)],

                [FlowState.BET, PunkRocker.presentationManager.addController([
                    modeRestorePresentation,
                    new FSStartPresentation(),
                ], PRGameMode.FREESPIN_LEVEL_ONE)],

                [FlowState.RESULT, PunkRocker.presentationManager.addController([
                    featurePlay,
                    normalStop,
                    normalStopped
                ], PRGameMode.FREESPIN_LEVEL_ONE)],

                [FlowState.WIN, PunkRocker.presentationManager.addController([
                    normalWin,
                    bigWin,
                    fsPauseBetweenSpins,
                    capWin,
                    modePresentation,
                    new OutroPresentation()
                ], PRGameMode.FREESPIN_LEVEL_ONE)],
            ]));

            PunkRocker.gameFlowController.addGameModeFlowStatePresentationMap(PRGameMode.FREESPIN_LEVEL_TWO, new Map<FlowState, PresentationController>([
                [FlowState.IDLE, PunkRocker.presentationManager.addController([
                    zeroBet
                ], PRGameMode.FREESPIN_LEVEL_TWO)],

                [FlowState.BET, PunkRocker.presentationManager.addController([
                    modeRestorePresentation,
                    new FSStartPresentation(),
                ], PRGameMode.FREESPIN_LEVEL_TWO)],

                [FlowState.RESULT, PunkRocker.presentationManager.addController([
                    featurePlay,
                    normalStop,
                    normalStopped
                ], PRGameMode.FREESPIN_LEVEL_TWO)],

                [FlowState.WIN, PunkRocker.presentationManager.addController([
                    normalWin,
                    bigWin,
                    fsPauseBetweenSpins,
                    capWin,
                    modePresentation,
                    new OutroPresentation()
                ], PRGameMode.FREESPIN_LEVEL_TWO)],
            ]));

            PunkRocker.gameFlowController.addGameModeFlowStatePresentationMap(PRGameMode.FREESPIN_LEVEL_THREE, new Map<FlowState, PresentationController>([
                [FlowState.IDLE, PunkRocker.presentationManager.addController([
                    zeroBet
                ], PRGameMode.FREESPIN_LEVEL_THREE)],

                [FlowState.BET, PunkRocker.presentationManager.addController([
                    modeRestorePresentation,
                    new FSStartPresentation(),
                ], PRGameMode.FREESPIN_LEVEL_THREE)],

                [FlowState.RESULT, PunkRocker.presentationManager.addController([
                    featurePlay,
                    normalStop,
                    normalStopped
                ], PRGameMode.FREESPIN_LEVEL_THREE)],

                [FlowState.WIN, PunkRocker.presentationManager.addController([
                    normalWin,
                    bigWin,
                    fsPauseBetweenSpins,
                    capWin,
                    new OutroPresentation()
                ], PRGameMode.FREESPIN_LEVEL_THREE)],
            ]));
            this.handleSweepInit();
            return value;
        })
    }

    // Player presses the start button.
    public start(): Promise<NolimitPlugin> {
        const initData: InitData = PunkRocker.model.initData;
        if (initData.isRestoreState) {
            if(initData.isFreeSpin) {
                PunkRocker.trainsManager.topTrain.toggleDisplay(true);

                let flag: boolean = initData.mode === PRGameMode.FREESPIN_LEVEL_ONE && !(initData.raw.bottomTrainEnabled);

                if(initData.nextMode === PRGameMode.FREESPIN_LEVEL_TWO || initData.nextMode === PRGameMode.FREESPIN_LEVEL_THREE) {
                    flag = false;
                }

                PunkRocker.noService.toggleServiceBoard(flag);
                PunkRocker.trainsManager.bottomTrain.toggleDisplay(!flag);
                PunkRocker.waysCounter.counterActive(false);
            }
            PunkRocker.keypadPlugin.setWin(initData.raw.accumulatedRoundWin, true, initData.Win.isWinBelowStake());
        }

        //User has pressed continue and the game starts.
        return super.start().then((value: NolimitPlugin) => {
            SoundManager.playAmbientLoop(PunkRocker.model.initData.mode);
            PunkRocker.gameFlowController.start();
            return value;
        });
    }

    public createViewsAndComponents(): void {
        if (GameSetting.isDevMode) {
            console.log(PunkSymbolData.getAllConfigs());
            this.addLayer(new Speedster())
            this.addLayer(new TestTool(PunkRocker.model))
        }

        PunkRocker.reelEngineManager = new PREngineManager(6,
            GameConfig.REEL_ENGINE_CONFIG,
            PunkRocker.model.initData.Reel,
            (value: number) => PunkRocker.gameFlowController.calculatePaddingDuration(value)  // ReelManager should NOT have dependencies to GameFlowController.
        );
        PunkRocker.capWinView = this.addLayer(new CapWinView());
        PunkRocker.bigWinView = this.addLayer(new BigWinView());
        PunkRocker.fsOutro = this.addLayer(new FSOutroView());
        PunkRocker.splashController = this.addLayer(new SplashController());
        PunkRocker.screenDimmer = this.addLayer(new ScreenDimmer());
        PunkRocker.overlayAnim = new OverlayAnimation();
        PunkRocker.counter = this.addLayer(new PunkBitmapCountUp());
        PunkRocker.posterManager = this.addLayer(new PosterManager());
        PunkRocker.fadedWinView = this.addLayer(new PRFadedWinView());
        PunkRocker.jumpWilds = this.addLayer(new JumpingWildController());

        PunkRocker.otherOverlays = new OtherOverlays();
        this.addLayer(PunkRocker.otherOverlays);

        this.addLayer(PunkRocker.overlayAnim);

        PunkRocker.noService = new NoServiceView();
        this.addLayer(PunkRocker.noService);

        PunkRocker.foreground = this.addLayer(new Foreground());

        PunkRocker.trainsManager = new TrainsManager();
        this.addLayer(PunkRocker.trainsManager);

        PunkRocker.gameLogo = this.addLayer(new GameLogo());

        this.addLayer(PunkRocker.reelEngineManager);

        PunkRocker.waysCounter = new WaysCounter();
        this.addLayer(PunkRocker.waysCounter);

        PunkRocker.background = this.addLayer(new Background());

        // #354
        PunkRocker.BURNING_JUMPING_WILDS_COUNT = 0;

        if (PunkRocker.model.data.isRestoreState) {
            const nextMode: PRGameMode = PunkRocker.model.data.nextMode;

            if(nextMode === PRGameMode.FREESPIN_LEVEL_ONE || nextMode === PRGameMode.FREESPIN_LEVEL_TWO || nextMode === PRGameMode.FREESPIN_LEVEL_THREE) {
                PunkRocker.background.setBgAnim((PunkRocker.model.data.nextMode === PRGameMode.FREESPIN_LEVEL_THREE ? "bonusGameStatic2" : "bonusGameStatic"), true);
                PunkRocker.background.setFrameAnim("bonusGameStatic", true).eventCallback("onComplete", () => {
                    if (PunkRocker.BURNING_JUMPING_WILDS_COUNT) {
                        PunkRocker.background.setFrameAnim("skull_" + PunkRocker.BURNING_JUMPING_WILDS_COUNT, true, true);
                    }
                });

                // #365
                if (nextMode === PRGameMode.FREESPIN_LEVEL_THREE) {
                    PunkRocker.foreground.playForegroundAnimation("burning_train");
                }
            }else{
                PunkRocker.background.setBgAnim("mainGameStatic", true);
                PunkRocker.background.setFrameAnim("mainGameStatic");

                // #365
                PunkRocker.foreground.playForegroundAnimation("static");
            }
        } else {
            PunkRocker.background.setBgAnim("mainGameStatic", true);
            PunkRocker.background.setFrameAnim("mainGameStatic");

            // #365
            PunkRocker.foreground.playForegroundAnimation("static");
        }
    }

    private addLayer(layer: any, order: number = 0): any {
        NolimitApplication.addLayerAt(layer.name, layer, order);
        return layer;
    }

    private onSelectedFeatureBetChanged = () => {
        const activeBetFeature = PunkRocker.apiPlugin.betFeatureController.getActiveBetFeature();

        PunkRocker.IS_BOOSTED_BET = activeBetFeature?.name == "BOOSTED_BET";
    }

    public static getBottomTrainStatus(): boolean {
        let rawGameData: BaseServerData = PunkRocker.model.gameData.raw,
            flag: boolean = rawGameData.bottomTrainEnabled ? rawGameData.bottomTrainEnabled : false;

        if(flag && rawGameData.topTrain.includes("ENABLE_TRAIN") && !(rawGameData.isRestoreState)) {
            flag = false;
        }

        if(rawGameData.nextMode === PRGameMode.FREESPIN_LEVEL_TWO || rawGameData.nextMode === PRGameMode.FREESPIN_LEVEL_THREE) {
            flag = true;
        }

        return flag;
    }

    private static getSymbolString(key: string, data: { [numSymbols: number]: number }): string {
        return `
            <div class="symbol">
            <img src="{{gamePath}}screens/images/symbols/${key}.png">
            <div class="payout-group">
                <div class="payout">
                    <span class="number">6</span>
                    <span class="multiplier" data-multiplier="${data[6] * 0.05}">${data[6] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">5</span>
                    <span class="multiplier" data-multiplier="${data[5] * 0.05}">${data[5] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">4</span>
                    <span class="multiplier" data-multiplier="${data[4] * 0.05}">${data[4] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">3</span>
                    <span class="multiplier" data-multiplier="${data[3] * 0.05}">${data[3] * 0.05}</span>
                </div>
            </div>
            </div>
        `;
    }

    public getPaytable(): Promise<string> {
        const templateLoader: TemplateLoader = new TemplateLoader(SlotGame.apiPlugin.resources.getStaticRoot());

        templateLoader.add({
            name: "Paytable",
            url: "nolimit/screens/paytable.mustache"
        });

        let symbolDataValueData: ISymbolValues = {
            "L1": {3: 5, 4: 10, 5: 20, 6: 20},
            "L2": {3: 5, 4: 10, 5: 20, 6: 20},
            "L3": {3: 4, 4: 8, 5: 15, 6: 20},
            "L4": {3: 3, 4: 6, 5: 15, 6: 20},
            "L5": {3: 3, 4: 6, 5: 15, 6: 20},
            "M1": {3: 15, 4: 30, 5: 80, 6: 20},
            "M2": {3: 10, 4: 20, 5: 60, 6: 20},
            "M3": {3: 9, 4: 18, 5: 40, 6: 20},
            "M4": {3: 8, 4: 16, 5: 25, 6: 20},
            "M5": {3: 7, 4: 14, 5: 25, 6: 20}
        };

        if (PunkRocker.model.initData.symbolValues) {
            symbolDataValueData = PunkRocker.model.initData.symbolValues;
        }


        const data = {
            skinPath:"screens/images/",
            sweepPath:"bonus/"
        };

        if (this.skinner.skinId != undefined){
            if(this.skinner.skinId === "sweep"){
                data.sweepPath = `../resources/images/${this.skinner.skinId}/`;
            }else {
                data.skinPath = `../resources/images/${this.skinner.skinId}/`;
            }
        }

        return templateLoader.load().then((assets: TemplateAsset[]) => {
            for (let asset of assets) {
                if (asset.name === "Paytable" && asset.loadedData) {
                    for (let key in symbolDataValueData) {
                        asset.loadedData = asset.loadedData!.replace(`{{${key}}}`, PunkRocker.getSymbolString(key, symbolDataValueData[key]))
                    }
                    asset.loadedData = asset.loadedData.replace(/{{sweepPath}}/g, data.sweepPath);
                    asset.loadedData = asset.loadedData.replace(/{{skinPath}}/g, data.skinPath);


                    return asset.loadedData;
                }
            }
            throw new Error("Disturbed could not load Paytable");
        });
    }
}